import type { GridProps } from "@ecco/ui/grid";
import type { FlexProps } from "@ecco/ui/flex";
import type { BoxProps } from "@ecco/ui/box";
import type { TextProps } from "@ecco/ui/text";
import { space } from "@ecco/ui/tokens";

export const ProductListWrapperStyles = {
    flexDirection: "column",
    alignItems: "center",
    gap: [0, 7],
    backgroundColor: "white",
    pt: [0, 0, 8],
};

export const ProductListStyles = (hasWidget: boolean): GridProps["sx"] => {
    return {
        width: "100%",
        gridTemplateColumns: [
            "repeat(2, 1fr)",
            "repeat(2, 1fr)",
            "repeat(3, 1fr)",
            "repeat(4, 1fr)",
            "repeat(4, 1fr)",
            "repeat(4, 1fr)",
        ],
        gridAutoRows: [hasWidget ? "auto" : "110vw", "80vw", "55vw", "45vw", "40vw", "800px"],
        gap: space["0.2"],
        rowGap: [0, 12],
        justifyContent: "space-between",
    };
};

export const EditorialWidgetStyles: GridProps["sx"] = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    inset: "0 0",
    padding: [3, 4, 6],
};

export const EditorialContentCardStyles = {
    wrapper: {
        flexDirection: "column",
        width: "100%",
        bg: "white",
        overflow: "hidden",
    } satisfies FlexProps,
    imageWrapper: {
        aspectRatio: "8/5",
        position: "relative",
        width: "100%",
        flexShrink: 0,
        pt: [3, 0],
        px: [3, 0],
    } satisfies BoxProps,
    content: {
        flexDirection: "column",
        flexShrink: 0,
        gap: 2,
        pt: 4,
        pb: 5,
        px: [3, 4],
        width: "100%",
    } satisfies FlexProps,
    title: {
        color: "black",
        fontSize: "16px",
        fontWeight: "bold",
        lineHeight: "24px",
        letterSpacing: "0.2px",
    } satisfies TextProps["sx"],
    description: {
        color: "gray.500",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.6px",
    } satisfies TextProps["sx"],
    linkWrapper: {
        pt: 3,
        pb: 0,
    } satisfies BoxProps,
    linkLabel: {
        display: "inline-block",
        color: "black",
        fontSize: ["14px", "16px"],
        fontWeight: "bold",
        lineHeight: "16px",
        letterSpacing: "0.4px",
        borderBottom: "1px solid",
        borderColor: "black",
        py: "6px",
    } satisfies BoxProps,
};
